import { TargetCostData } from '@/types/target-cost';
import { supabase } from './client';
import { logError } from '@/utils/logger';

export async function fetchTargetCostCalculations() {
  const { data, error } = await supabase
    .from('target_cost_calculations')
    .select('*')
    .order('date_saved', { ascending: false });

  if (error) {
    logError('Error fetching calculations:', error);
    throw new Error('Failed to fetch calculations');
  }

  return data;
}

export async function saveTargetCostCalculation(
  projectName: string,
  data: TargetCostData
) {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user) {
    throw new Error('User must be authenticated to save calculations');
  }

  const { data: savedData, error } = await supabase
    .from('target_cost_calculations')
    .insert({
      project_name: projectName,
      data,
      user_id: user.id,
    })
    .select()
    .single();

  if (error) {
    logError('Error saving calculation:', error);
    throw new Error('Failed to save calculation');
  }

  return savedData;
}

export async function renameTargetCostCalculation(
  id: string,
  newName: string
): Promise<void> {
  const { error } = await supabase
    .from('target_cost_calculations')
    .update({ project_name: newName })
    .eq('id', id);

  if (error) {
    logError('Error renaming calculation:', error);
    throw new Error('Failed to rename calculation');
  }
}

export async function deleteTargetCostCalculation(id: string): Promise<void> {
  const { error } = await supabase
    .from('target_cost_calculations')
    .delete()
    .eq('id', id);

  if (error) {
    logError('Error deleting calculation:', error);
    throw new Error('Failed to delete calculation');
  }
}